import { staticText } from '../../utils/translations/staticText';

// zh copy supplied by design on CMS-1865 (comment 215525) — not invented here.
export const TRANSLATIONS = staticText({
  image_carousel_previous_slide: {
    _: 'Previous slide',
    zh: '上一頁',
  },
  image_carousel_next_slide: {
    _: 'Next slide',
    zh: '下一頁',
  },
});

export type ImageCarouselTranslations = typeof TRANSLATIONS;
